import React from "react";
import "../styles/Notice.css";

export default function Notice() {

  // LocalStorage मधून notices
  const notices = JSON.parse(localStorage.getItem("notices")) || [];

  return (
    <div className="notice-page">
      <h1 className="notice-title">🔔 सूचना फलक</h1>
      <p className="notice-subtitle">
        गावातील महत्वाच्या सूचना व जाहीराती
      </p>

      <div className="notice-list">

        {notices.length === 0 ? (
          <div className="no-notice">
            🚫 सध्या कोणतीही सूचना उपलब्ध नाही
          </div>
        ) : (
          notices.map((notice, index) => (
            <div
              key={index}
              className={`notice-card ${
                notice.type === "new"
                  ? "new"
                  : notice.type === "important"
                  ? "important"
                  : ""
              }`}
            >
              {notice.type === "new" && (
                <span className="badge">नवीन</span>
              )}
              {notice.type === "important" && (
                <span className="badge red">महत्वाची</span>
              )}

              <h3>{notice.title}</h3>
              <p>{notice.message}</p>
              <span className="date">🗓️ {notice.date}</span>
            </div>
          ))
        )}

      </div>
    </div>
  );
}
